module.exports = __webpack_public_path__ + "static/img/qiepian22.7ebab36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qiepian22.png
// module id = 4TYo
// module chunks = 2